import axios from "axios"
import store from '../store'
// import cookie from 'vue-cookie'

const $axios = axios.create({
   baseURL: process.env.VUE_APP_API_WEB_URL + '/wp-json/wp/v2',
   headers: {
      'Content-Type': 'application/json'
   },
})

$axios.interceptors.request.use(function (config) {
   const token = store.state.token
   if (token) config.headers.Authorization = `Bearer ${token}`
   return config
}, function (error) {
   return Promise.reject(error)
})

$axios.interceptors.response.use(function (response) {
   return response
}, function (error) {
   // const token = store.state.token
   // if(error.response.status !== 403 && !token && error.response.status !== 422) {
   //    forceLogout()
   // }
   if (error.response.status === 401) {
      forceLogout()
   }

   return Promise.reject(error)
})

const forceLogout = () => {
   store.dispatch('forceLogout')
   window.location.replace('/login')
}

export default $axios
